export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
export const RESET_UPLOAD_PROGRESS = "RESET_UPLOAD_PROGRESS";
